import { Routes } from '@angular/router';
import { AuthGuard } from '../../guard/auth-guard/auth.guard';

export const painelMaavRoutes: Routes = [
  {
    path: 'painel_maav',
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        data: {
          title: 'Módulo de Acolhimento e Avaliação (MAAv)',
          breadcrumb: [{ label: 'Painel MAAv', url: '/painel_maav' }],
        },
        loadComponent: () =>
          import('./painel-maav.component').then((m) => m.PainelMaavComponent),
      },
      {
        path: 'participar/:id',
        data: {
          title: 'Módulo de Acolhimento e Avaliação (MAAv)',
          breadcrumb: [
            { label: 'Painel MAAv', url: '/painel_maav' },
            { label: 'Participar MAAv' },
          ],
        },
        loadComponent: () =>
          import('./participar/maav-participar.component').then(
            (m) => m.MaavParticiparComponent,
          ),
      },
    ],
  },
];
